import classNames from 'classnames';
import { bool, func, number, object, string } from 'prop-types';
import React, { useEffect, useState } from 'react';

import {
  Avatar,
  InlineTextButton,
  LinkedLogo,
  Menu,
  MenuContent,
  MenuItem,
  MenuLabel,
  NamedLink,
  OutsideClickHandler,
} from '../../../../components';
import { ACCOUNT_SETTINGS_PAGES } from '../../../../routing/routeConfiguration';
import { FormattedMessage, intlShape } from '../../../../util/reactIntl';
import {
  abilityToSell,
  propTypes,
  USER_TYPE_YOUTH
} from '../../../../util/types';


import NotificationDropdown from '../../../../components/NotificationDropdown/NotificationDropdown';
import ProfileIconCard from '../../../../components/ProfileIconCard/ProfileIconCard';
import MenuIcon from '../MenuIcon';
import css from './TopbarDesktop.module.css';
import { cartItemsCount, currentUserRole, getUserPermissions } from '../../../../util/data';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../../../util/routes';
import { openIntecomOnClickEvents } from '../../../../components/IntercomComponent/IntercomComponent';
const isActive = typeof window != "undefined" && location && location.pathname === '/p/about';

const toNotificationCount = value => {
  const count = Number(value);
  return Number.isFinite(count) ? count : 0;
};

const getUnreadNotificationCountFromList = notificationsData => {
  const { records = [], mongoNotifications = [] } = notificationsData || {};
  const circleUnreadCount = Array.isArray(records)
    ? records.filter(item => !item?.read_at).length
    : 0;
  const mongoUnreadCount = Array.isArray(mongoNotifications)
    ? mongoNotifications.filter(item => item?.read === false).length
    : 0;

  return circleUnreadCount + mongoUnreadCount;
};

// {old code for signup route}

const authSearchMaybe = shopifyToken =>
  shopifyToken ? { search: `?shopify_token=${encodeURIComponent(shopifyToken)}` } : {};

const SignupLink = ({ shopifyToken }) => {
  return (
    <NamedLink name="SignupPage" to={authSearchMaybe(shopifyToken)} className={css.signupButton}>
      <span className={css.topbarLinkLabels}>
        <FormattedMessage id="TopbarDesktop.signup" />
      </span>
    </NamedLink>
  );
};

// {join waitlist button redirect to iframe section}
const scrollToSection = () => {
  const targetSection = document.getElementById("iframe-section");
  if (targetSection) {
    targetSection.scrollIntoView({ behavior: "smooth" });
  }
};

// const SignupLink = () => {
//   return (
//     <div
//       name="SignupPage"
//       className={css.signupButton}
//       onClick={scrollToSection}
//     >
//       <span className={css.topbarLinkLabels}>
//         <FormattedMessage id="TopbarDesktop.signup" />
//       </span>
//     </div>
//   );
// };

const LoginLink = ({ shopifyToken }) => {
  return (
    <NamedLink name="LoginPage" to={authSearchMaybe(shopifyToken)} className={css.loginButton}>
      <span className={css.topbarLinkLabels}>
        <FormattedMessage id="TopbarDesktop.login" />
      </span>
    </NamedLink>
  );
};

const AboutusLink = () => {
  return (
    <NamedLink name="CMSPage"
      params={{ pageId: "about" }}
      className={`${css.communityLink} ${isActive ? css.activeLink : ""}`}>
      <FormattedMessage id='TopbarDesktop.AboutUs' />
    </NamedLink>
  );
};
const MarketplaceLink = () => {
  return (
    <NamedLink
      name="SearchPage"
      className={css.communityLink}
      activeClassName={css.activeLink}
    >
      <FormattedMessage id="TopbarDesktop.MarketplaceDropdown" />
    </NamedLink>
  );
};
const AiLandingLink = ({ isAuthenticated }) => {
  return (
    <NamedLink
      name={isAuthenticated ? "RuleBooksSearchPage" : "CMSPage"}
      params={isAuthenticated ? { rulebookId: 'recent' } : { pageId: "ai-landing-page" }}
      className={css.communityLink}
      activeClassName={css.activeLink}>
      <FormattedMessage id="TopbarDesktop.ailandingPage" />
    </NamedLink>
  );
};
const CommunityPageLink = ({ isAuthenticated }) => {
  return (
    <NamedLink
      className={css.communityLink}
      activeClassName={css.activeCommunityLink}
      name={isAuthenticated ? "CircleCommunityPage" : "GroupSearchPage"}
    >
      {isAuthenticated ? "My Feed" : "Community"}
    </NamedLink>
  );
};

const DirectoryLink = () => {
  return (
    <NamedLink
      name="AlgoliaDirectorySearchPage"
      className={css.communityLink}
      activeClassName={css.activeLink}
    >
      <FormattedMessage id="TopbarDesktop.Directory" />
    </NamedLink>
  );
};

const DealsDiscount = () => {
  return (
    <NamedLink
      name="DiscountsLandingPage"
      className={css.communityLink}
      activeClassName={css.activeLink}
    >
      <FormattedMessage id="TopbarDesktop.DealsDiscount" />
    </NamedLink>
  );
};

const InboxLink = ({ notificationCount, currentUserHasListings }) => {
  const notificationDot = notificationCount > 0 ? <div className={css.notificationDot} /> : null;
  return (
    <NamedLink
      className={css.topbarLinks}
      name="InboxPage"
      params={{ tab: currentUserHasListings ? 'sales' : 'orders' }}
    >
      <span className={css.topbarLinkLabels}>
        <ProfileIconCard type="cart" />
        {/* <FormattedMessage id="TopbarDesktop.inbox" /> */}
        {notificationDot}
      </span>
    </NamedLink>
  );
};

const CartLink = ({ notificationCount }) => {
  const notificationDot = notificationCount > 0 ? <div className={css.notificationCountCart} >{notificationCount}</div> : null;
  return (
    <NamedLink
      className={css.topbarLink}
      name="CartPage"
    >
      <span className={css.topbarLinkLabel}>
        <ProfileIconCard type="cart" />
        {/* <FormattedMessage id="TopbarDesktop.cart" /> */}
        {notificationDot}
      </span>
    </NamedLink>
  );
};

export const ProfileMenu = ({
  currentPage,
  currentUser,
  onLogout,
  isAuthenticated,
  cartNotificationCount,
  inboxNotificationCount,
  userAbilityToSell,
  currentUserOrderNotificationCount
}) => {
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();

  const userId = currentUser?.id?.uuid;
  const currentPageClass = (pageName, pageParams) => {
    const isAccountSettingsPage =
      pageName === 'AccountSettingsPage' && ACCOUNT_SETTINGS_PAGES.includes(currentPage);

    // Handle CMSPage with pageId parameter (e.g., CMSPage:faq, CMSPage:about)
    const isCMSPage = pageName === 'CMSPage' && pageParams?.pageId &&
      currentPage === `CMSPage:${pageParams.pageId}`;

    // Handle InboxPage with tab parameter
    const isInboxPage = pageName === 'InboxPage' && pageParams?.tab &&
      currentPage === `InboxPage:${pageParams.tab}`;

    // Handle regular pages without parameters
    const isCurrentPage = currentPage === pageName;

    return isCMSPage || isInboxPage || isCurrentPage || isAccountSettingsPage
      ? css.currentPage
      : null;
  };

  const { publicData = {}, protectedData = {}, privateData = {} } =
    currentUser?.attributes?.profile || {};

  const { userRole, parentId = false } = publicData || {};
  const { subscriptionData = false } = protectedData || {};
  const { isSupabaseAdmin, isOrganizationAdmin, isWalletAdmin } = privateData || {};

  const isYouthRestricted = userRole === USER_TYPE_YOUTH && parentId && !subscriptionData;

  const getAuthenticatedItems = () => {
    const menuItems = [
      // {
      //   key: 'RuleBooksSearchPage',
      //   name: 'RuleBooksSearchPage',
      //   messageId: 'TopbarDesktop.aiPageLink',
      //   params: { rulebookId: 'recent' },
      // },
      // {
      //   key: 'CircleCommunityPage',
      //   name: 'CircleCommunityPage',
      //   messageId: 'TopbarDesktop.CommunityDropdown',
      // },
      // {
      //   key: 'SearchPage',
      //   name: 'SearchPage',
      //   messageId: 'TopbarDesktop.MarketplaceDropdown',
      // },
      // ...(userAbilityToSell ? [{
      //   key: 'ManageListingsPage',
      //   name: 'ManageListingsPage',
      //   messageId: 'TopbarDesktop.yourListingsLink',
      // }] : []),
      // ...(!isYouthRestricted ? [{
      //   key: 'CartPage',
      //   name: 'CartPage',
      //   messageId: 'TopbarDesktop.yourCartLink',
      //   notification: cartNotificationCount > 0 && (
      //     <div className={css.notificationProfileCartMenu} />
      //   )
      // },
      // {
      //   key: 'InboxPage',
      //   name: 'InboxPage',
      //   messageId: 'TopbarDesktop.inbox',
      //   params: { tab: 'orders' },
      //   notification: (inboxNotificationCount + currentUserOrderNotificationCount) > 0 && (
      //     <div className={css.notificationProfileInboxMenu}>
      //       {inboxNotificationCount + currentUserOrderNotificationCount}
      //     </div>
      //   )
      // }] : []),
      // {
      //   key: 'ProfileSettingsPage',
      //   name: 'ProfileSettingsPage',
      //   messageId: 'TopbarDesktop.profileSettingsLink',
      // },
      {
        key: 'ProfileSettingsPage',
        name: 'ProfileSettingsPage',
        messageId: 'TopbarDesktop.accountSettingsLink',
      },
      // {
      //   key: 'ShopifyOnboardingPageTab',
      //   name: 'ShopifyOnboardingPageTab',
      //   messageId: 'TopbarDesktop.shopifyOnboarding',
      //   params: { tab: 'connect' },
      // },
      {
        key: 'support',
        name: 'LoginPage',
        messageId: 'TopbarDesktop.support',
        isButton: true,
        onClick: () => {
          // Handle login click
          if (userId) {
            openIntecomOnClickEvents()
          } else {
            history.push("/login")
          }
        }
      },
      {
        key: 'CMSPageFaq',
        name: 'CMSPage',
        params: { pageId: 'faq' },
        messageId: 'TopbarDesktop.faq',
      },
      {
        key: 'CMSPageabout',
        name: 'CMSPage',
        params: { pageId: 'about' },
        messageId: 'TopbarDesktop.about',
      },
      {
        key: 'blog',
        name: 'LoginPage',
        isButton: true,
        messageId: 'TopbarDesktop.blog',
        onClick: () => {
          if (typeof window !== "undefined" && window) {
            window.open(`${process.env.REACT_APP_GHOST_APP_URL}`, "_self");
          };
        }
      },
      //  ...(isOrganizationAdmin || isSupabaseAdmin || isWalletAdmin ? [{
      //   key: isSupabaseAdmin ? "AdminPanelSupabasePage" : isOrganizationAdmin ? 'AdminPanelOrganisationPage' : "AdminPanelWalletPage" ,
      //   name: isSupabaseAdmin ? "AdminPanelSupabasePage" : isOrganizationAdmin ? 'AdminPanelOrganisationPage' : "AdminPanelWalletPage",
      //   params: { tab: "general" },
      //   messageId: 'LayoutWrapperAccountSettingsSideNav.AdminPanelTitle',
      // }] : []),
      // ...(isOrganizationAdmin ? [{
      //   key: 'AdminPanelOrganisationPage',
      //   name: 'AdminPanelOrganisationPage',
      //   messageId: 'LayoutWrapperAccountSettingsSideNav.AdminPanelOrganisationPageTabTitle',
      // }] : []),
      // ...(isSupabaseAdmin ? [{
      //   key: 'AdminPanelSupabasePage',
      //   name: 'AdminPanelSupabasePage',
      //   params: { tab: "general" },
      //   messageId: 'TopbarDesktop.adminPanelLink',
      // }] : []),
      // ...(isWalletAdmin ? [{
      //   key: 'AdminPanelWalletPage',
      //   name: 'AdminPanelWalletPage',
      //   messageId: 'LayoutWrapperAccountSettingsSideNav.AdminPanelWalletPage',
      // }] : []),
      // {
      //   key: 'StripeSubscriptionPage',
      //   name: 'StripeSubscriptionPage',
      //   messageId: 'UserNav.stripeSubscriptionPage',
      // },
      {
        key: 'logout',
        messageId: 'TopbarDesktop.logout',
        isButton: true,
        onClick: onLogout,
        isLast: true
      }
    ];

    return menuItems;
  };

  const getNonAuthenticatedItems = () => [
    {
      key: 'login',
      name: 'LoginPage',
      messageId: 'TopbarDesktop.login',
    },
    {
      key: 'support',
      name: 'LoginPage',
      messageId: 'TopbarDesktop.support',
      isButton: true,
      onClick: () => {
        if (userId) {
          openIntecomOnClickEvents()
        } else {
          history.push("/login")
        }
      }
    },
    {
      key: 'CMSPageFaq',
      name: 'CMSPage',
      params: { pageId: 'faq' },
      messageId: 'TopbarDesktop.faq',
    },
    {
      key: 'CMSPageabout',
      name: 'CMSPage',
      params: { pageId: 'about' },
      messageId: 'TopbarDesktop.about',
    },
    {
      key: 'blog',
      name: 'LoginPage',
      isButton: true,
      messageId: 'TopbarDesktop.blog',
      onClick: () => {
        // Handle login click
        if (typeof window !== "undefined" && window) {
          window.open(`${process.env.REACT_APP_GHOST_APP_URL}`, "_self");
        };
      }
    },

    // ...(userAbilityToSell ? [{
    //   key: 'ManageListingsPage',
    //   name: 'ManageListingsPage',
    //   messageId: 'TopbarDesktop.yourListingsLink',
    // }] : []),
    // {
    //   key: 'StripeSubscriptionPage',
    //   name: 'StripeSubscriptionPage',
    //   messageId: 'UserNav.stripeSubscriptionPage',
    // },
    // {
    //   key: 'login',
    //   name: 'LoginPage',
    //   messageId: 'TopbarDesktop.login',
    // },
    {
      key: 'signup',
      name: 'SignupPage',
      messageId: 'TopbarDesktop.signup',
      isLast: true
    },
  ];

  const renderMenuItem = item => {
    if (item.isButton) {
      return (
        <MenuItem key={item.key}>
          <InlineTextButton rootClassName={item.isLast ? css.logoutButton : css.menudropDownLink} onClick={item.onClick}>
            <span className={css.menuItemBorder} />
            <FormattedMessage id={item.messageId} />
          </InlineTextButton>
        </MenuItem>
      );
    }

    const isCurrentPage = currentPageClass(item.name, item.params);

    return (
      <MenuItem key={item.key}>
        <InlineTextButton
          className={classNames(item.isLast ? css.logoutButton : css.menuLink, isCurrentPage)}
          name={item.name}
          params={item.params}
          onClick={(e) => {
            e.preventDefault();
            const params = item.params || {};
            if (typeof window != "undefined") {
              return isCurrentPage ? window.location.reload() : history.push(
                createResourceLocatorString(
                  item.name,
                  routeConfiguration,
                  { ...params },
                )
              );
            }
          }}
        >
          <span className={css.menuItemBorder} />
          <FormattedMessage id={item.messageId} />
          {item.notification}
        </InlineTextButton>
      </MenuItem>
    );
  };

  const menuItems = isAuthenticated ? getAuthenticatedItems() : getNonAuthenticatedItems();

  return (
    <Menu>
      <MenuLabel className={css.profileMenuLabel} isOpenClassName={css.profileMenuIsOpen}>
        {isAuthenticated
          ? <><Avatar className={css.avatar} user={currentUser} disableProfileLink /> {" "} <ProfileIconCard type="dropdown" /></>
          : <MenuIcon />}
      </MenuLabel>
      <MenuContent className={isAuthenticated ? css.profileMenuContent : css.profileMenuContentLogout}>
        {menuItems.map(renderMenuItem)}
      </MenuContent>
    </Menu>
  );
};


const TopbarDesktop = props => {
  const location = useLocation();
  const {
    className,
    config,
    customLinks,
    currentUser,
    currentPage,
    rootClassName,
    currentUserHasListings,
    notificationCount,
    intl,
    isAuthenticated,
    onLogout,
    onSearchSubmit,
    initialSearchFormValues,
    onFetchNotifications,
    onSuccessNotifications,
    isMobileLayout,
    requestNotificationsInProgress,
    notificationsData,
    onFetchNotificationsCount,
    onMarkNotificationRead,
    notificationCountData,
    onResetNotificationsCount,
    onMarkAllNotificationsAsRead,
    onGetNotificationPreference,
    requestNotificationPreferenceInProgress,
    notificaitonPreferenceData,
    onUpdateNotificationPreference,
    currentUserOrderNotificationCount = 0
  } = props;
  const [mounted, setMounted] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (currentUser) {
      onFetchNotificationsCount({ forceFresh: true });
    }
    setMounted(true);
  }, []);

  const handleToggleDropdown = () => {
    const nextIsOpen = !isOpen;
    setIsOpen(nextIsOpen);
    if (nextIsOpen) {
      onFetchNotifications({ forceFresh: true });
    }
    onResetNotificationsCount()
  };
  const marketplaceName = config.marketplaceName;
  const authenticatedOnClientSide = mounted && isAuthenticated;
  const isAuthenticatedOrJustHydrated = isAuthenticated || !mounted;

  const giveSpaceForSearch = customLinks == null || customLinks?.length === 0;
  const classes = classNames(rootClassName || css.root, className);

  const { cart } = currentUser?.attributes.profile.privateData || {};

  const cartCount = cartItemsCount(cart);

  const { new_notifications_count = 0, new_mentions_count = 0, } = notificationCountData || {};
  const totalNotificationCount = Math.max(
    toNotificationCount(new_notifications_count) + toNotificationCount(new_mentions_count),
    getUnreadNotificationCountFromList(notificationsData)
  );
  const cartLinkMaybe = authenticatedOnClientSide ? (
    <CartLink
      notificationCount={cartCount}
    />
  ) : null;
  const inboxLinkMaybe = authenticatedOnClientSide ? (
    <InboxLink
      notificationCount={notificationCount}
      currentUserHasListings={currentUserHasListings}
    />
  ) : null;
  const messageLinkMaybe = authenticatedOnClientSide ? (
    <NamedLink className={css.topbarLinks} name="InboxPage" params={{ tab: "orders" }}>
      <ProfileIconCard type="messanger" />
      {(currentUserOrderNotificationCount || notificationCount || props.currentUserUnreadInquiriesCount) > 0 ? (
        <div className={css.notificationCount}>
          {currentUserOrderNotificationCount + notificationCount + (props.currentUserUnreadInquiriesCount || 0)}
        </div>
      ) : null}
    </NamedLink>
  ) : null;

  const handleNotificationDropdownOutsideClick = () => {
    if (isMobileLayout) return
    setIsOpen(false);
  };

  const notificationLinkMaybe = authenticatedOnClientSide ? (
    <OutsideClickHandler onOutsideClick={() => isOpen && handleNotificationDropdownOutsideClick()}>
      <div className={css.notificationWrapper}>
        <div className={css.topbarLinks}
          onClick={handleToggleDropdown}
        >
          {/* show counts from this notificationCountData */}
          <ProfileIconCard type="bell" />
          {totalNotificationCount > 0 ? <div className={css.notificationCount}>{totalNotificationCount}</div> : null}
        </div>
        {isOpen ?
          <div className={`${css.notificationDropdown} ${isOpen ? css.open : ''}`}>
            <NotificationDropdown
              requestNotificationPreferenceInProgress={requestNotificationPreferenceInProgress}
              notificaitonPreferenceData={notificaitonPreferenceData}
              onMarkAllNotificationsAsRead={onMarkAllNotificationsAsRead}
              onGetNotificationPreference={onGetNotificationPreference}
              onUpdateNotificationPreference={onUpdateNotificationPreference}
              onFetchNotifications={onFetchNotifications}
              requestNotificationsInProgress={requestNotificationsInProgress}
              notificationsData={notificationsData}
              setIsOpen={() => setIsOpen(false)}
              onMarkNotificationRead={onMarkNotificationRead}
              onFetchNotificationsCount={onFetchNotificationsCount} />
          </div>
          : null}
      </div>
    </OutsideClickHandler>
  ) : null;

  const userSubscriptionRole = currentUserRole(currentUser);
  const userAbilityToSell = getUserPermissions(userSubscriptionRole, abilityToSell);
  const searchParams = new URLSearchParams(location?.search || '');
  const shopifyToken = searchParams.get('shopify_token');
  // authenticatedOnClientSide
  const profileMenuMaybe = true ? (
    <ProfileMenu
      currentPage={currentPage}
      currentUser={currentUser}
      onLogout={onLogout}
      isAuthenticated={isAuthenticated}
      cartNotificationCount={cartCount}
      inboxNotificationCount={notificationCount}
      userAbilityToSell={userAbilityToSell}
      currentUserOrderNotificationCount={currentUserOrderNotificationCount}

    />
  ) : null;

  const signupLinkMaybe = isAuthenticatedOrJustHydrated ? null : <SignupLink shopifyToken={shopifyToken} />;
  const loginLinkMaybe = isAuthenticatedOrJustHydrated ? null : <LoginLink shopifyToken={shopifyToken} />;
  const aboutusMaybe = <AboutusLink />;
  const marketplaceMaybe = <MarketplaceLink />;
  const aiLandingPage = <AiLandingLink isAuthenticated={isAuthenticated} />;
  const communityPageLink = <CommunityPageLink isAuthenticated={isAuthenticated} />
  const directoryLink = authenticatedOnClientSide ? <DirectoryLink /> : null;
  // Discounts is public; logged-out visitors get the teaser page at /discounts.
  const dealsDiscountLink = <DealsDiscount />;

  const { publicData, protectedData } = (currentUser && currentUser.id && currentUser.attributes?.profile) || {};
  const { userRole, parentId = false } = publicData || {};
  const { subscriptionData = false } = protectedData || {};
  const youthAcccess = (userRole !== USER_TYPE_YOUTH && (subscriptionData || !parentId));

  return (
    <nav className={classes}>
      <div className={css.leftSide}>
        <LinkedLogo
          className={css.logoLink}
          layout="desktop"
          alt={intl.formatMessage({ id: 'TopbarDesktop.logo' }, { marketplaceName })}
          linkToExternalSite={config?.topbar?.logoLink}
        />
        {/* <TopbarSearchForm
          className={classNames(css.searchLink, { [css.takeAvailableSpace]: giveSpaceForSearch })}
          desktopInputRoot={css.topbarSearchWithLeftPadding}
          onSubmit={onSearchSubmit}
          initialValues={initialSearchFormValues}
          appConfig={config}
        /> */}
      </div>

      {/* Community  */}
      <div className={css.rightBox}>
        {/* <CustomLinksMenu
          currentPage={currentPage}
          customLinks={TopbarCommunityDropdown}
          intl={intl}
          hasClientSideContentReady={authenticatedOnClientSide || !isAuthenticatedOrJustHydrated}
          label={intl.formatMessage({ id: 'TopbarDesktop.CommunityDropdown' })}
        /> */}

        {communityPageLink}

        {/* MarketPlace  */}
        {marketplaceMaybe}
        {aiLandingPage}
        {directoryLink}
        {dealsDiscountLink}
        {/* <CustomLinksMenu
          currentPage={currentPage}
          customLinks={TopbarMarketPlaceDropdown}
          intl={intl}
          hasClientSideContentReady={authenticatedOnClientSide || !isAuthenticatedOrJustHydrated}
          label={intl.formatMessage({ id: 'TopbarDesktop.MarketplaceDropdown' })}
        /> */}

        {/* {aboutusMaybe} */}
        {youthAcccess ? messageLinkMaybe : null}
        {notificationLinkMaybe}
        {/* {inboxLinkMaybe} */}
        {youthAcccess ? cartLinkMaybe : null}
        {signupLinkMaybe}
        {loginLinkMaybe}
        {profileMenuMaybe}
      </div>

    </nav>
  );
};

TopbarDesktop.defaultProps = {
  rootClassName: null,
  className: null,
  currentUser: null,
  currentPage: null,
  notificationCount: 0,
  initialSearchFormValues: {},
  config: null,
};

TopbarDesktop.propTypes = {
  rootClassName: string,
  className: string,
  currentUserHasListings: bool.isRequired,
  currentUser: propTypes.currentUser,
  currentPage: string,
  isAuthenticated: bool.isRequired,
  onLogout: func.isRequired,
  notificationCount: number,
  onSearchSubmit: func.isRequired,
  initialSearchFormValues: object,
  intl: intlShape.isRequired,
  config: object,
};

export default TopbarDesktop;
